import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import SelectAsync from 'react-select/async';

export default class Constant extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            type: props.Type,
            caller: props.Caller,
            fromAutoComplete: this.isNull(props.FromAutoComplete) ? false : props.FromAutoComplete,
            data: null,
            loading: true
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();

        this.httpPost("api/v1/" + ((this.state.type == 1 || this.state.type == 2 || this.state.type == 4 || this.state.type == 7 || this.state.type == 11 || this.state.type == 12 || this.state.type == 13 || this.state.type == 14 || this.state.type == 15) ? 'constantfororganization' : 'constant') +"/get", {
            id: this.getCurrentFormId(),
            type: this.state.type,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.code)) this.state.data.record.code = 0;

        this.httpPost("api/v1/" + ((this.state.type == 1 || this.state.type == 2 || this.state.type == 4 || this.state.type == 7 || this.state.type == 11 || this.state.type == 12 || this.state.type == 13 || this.state.type == 14 || this.state.type == 15) ? 'constantfororganization' : 'constant') +"/save", {
            id: this.state.id,
            organizationId: this.state.data.global.company.id,
            parentId: this.state.data.record.parentId,
            type: this.state.data.record.type,
            name: this.state.data.record.name,
            quiddity: this.state.data.record.quiddity,
            code: parseInt(this.state.data.record.code)
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    if (this.state.fromAutoComplete)
                        this.state.caller.setGroup({ value: data.id, label: this.state.data.record.name });
                    else
                        this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setParent(e) {
        this.state.data.record.parentId = e.value;
        this.state.data.record.parentTitle = e.label;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{"min-width": "320px"}}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات" : "افزودن جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.name} onChange={e => this.state.data.record.name = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    {this.state.data.record.type === 10 && <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-label">والد</label>
                                            <div className="form-control-wrap">
                                                <SelectAsync
                                                    defaultValue={this.state.data.record.parentId === this.getDefaultGuid() ? null : [{ value: this.state.data.record.parentId, label: this.state.data.record.parentTitle }]}
                                                    isMulti={false}
                                                    placeholder="انتخاب کنید"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadConstantsOptions(inputValue, callback,10)}
                                                    onChange={e => this.setParent(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>}
                                    {this.state.data.record.type !== 10 && <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">کد</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.code} onChange={e => this.state.data.record.code = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="10" />
                                        </div>
                                    </div>}
                                    {this.state.data.record.type === 1 && <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">ماهیت</label><span className="red">*</span>
                                            <select defaultValue={this.state.data.record.quiddity} onChange={e => this.state.data.record.quiddity = parseInt(e.target.value)} autocomplete="off" className="form-control input-sm">
                                                <option value="0">انتخاب نمایید</option>
                                                <option value="1">مشتری</option>
                                                <option value="2">تامین کننده</option>
                                                <option value="3">کارمند</option>
                                                <option value="4">تنخواه گردان</option>
                                                <option value="6">ویزیتور</option>
                                                <option value="10">راننده</option>
                                                <option value="11">پیمانکار</option>
                                                <option value="12">کارفرما</option>
                                            </select>
                                        </div>
                                    </div>}
                                    {this.state.data.record.type === 4 && <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">ماهیت</label><span className="red">*</span>
                                            <select defaultValue={this.state.data.record.quiddity} onChange={e => this.state.data.record.quiddity = parseInt(e.target.value)} autocomplete="off" className="form-control input-sm">
                                                <option value="0">انتخاب نمایید</option>
                                                <option value="7">عمومی</option>
                                                <option value="8">افتتاحیه</option>
                                                <option value="9">اختتامیه</option>
                                                <option value="36">بستن حساب موقت</option>
                                                <option value="14">هزینه</option>
                                                {this.state.data.global.company.mainBussinessType === 4 && <option value="15">صورتحساب ساختمان</option>}
                                                <option value="16">فروش اقساطی</option>
                                                <option value="17">فروش</option>
                                                <option value="18">خرید</option>
                                                <option value="19">برگشت از خرید</option>
                                                <option value="20">برگشت از فروش</option>
                                                <option value="21">چک</option>
                                                <option value="22">دریافت و پرداخت</option>
                                                <option value="23">انبار</option>
                                                <option value="24">تنخواه</option>
                                                <option value="25">ضایعات</option>
                                                <option value="26">انبارگردانی</option>
                                                {this.state.data.global.company.mainBussinessType === 7 && <option value="27">فروش دام</option>}
                                                {this.state.data.global.company.mainBussinessType === 7 && <option value="28">خرید دام</option>}
                                                {this.state.data.global.company.mainBussinessType === 7 && <option value="29">تلفات دام</option>}
                                                {this.state.data.global.company.mainBussinessType === 7 && <option value="30">خوراک دام</option>}
                                                {this.state.data.global.company.mainBussinessType === 7 && <option value="31">واکسیناسیون دام</option>}
                                                <option value="32">فروش خدمات</option>
                                                <option value="33">خرید خدمات</option>
                                                <option value="34">خرید خارجی</option>
                                                <option value="35">تخصیص هزینه</option>
                                            </select>
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}